import { z } from "zod";
import { TimepotDate } from "models/TimepotDate";

// eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match
export const NationalHoliday = z.object({
    date: TimepotDate,
    name: z.string(),
});
export type NationalHoliday = z.infer<typeof NationalHoliday>;
